import {
  PRIMARY_BLUE,
  ACTION_TOOLBAR_BACKGROUND,
  DARKER_GREY,
  TEXT_PRIMARY_ACTION,
  TEXT_SECONDARY_ACTION,
  VERTICAL_SEPARATOR,
  combinedColor,
  PLAIN_GREY,
  OPACITY_MEDIUM,
} from '~/Constants/Colors.constants';
import { makeStyles } from '~/UIKit/Style';
import {
  FONT_SIZE_INBETWEEN,
  FONT_SIZE_MEDIUM_CONFUSED,
  FONT_SIZE_SMALL,
} from '~/Constants/UI.constants';
import { selectClasses } from '@mui/material';

export const useListToolbarStyles = makeStyles(
  (theme) => ({
    container: {
      display: 'grid',
      gridTemplateColumns: 'max-content max-content',
      justifyContent: 'space-between',
      position: 'sticky',
      justifyItems: 'end',
      background: ACTION_TOOLBAR_BACKGROUND,
      marginBottom: 34,
      marginTop: 1,
      [theme.breakpoints.down('md')]: {
        gridTemplateColumns: '1fr',
        rowGap: 20,
        margin: '0 16px 20px',
      },
    },
    selectionBox: {
      fontSize: '12px',
      fontWeight: 'bold',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gridArea: 'select',
      overflow: 'hidden',
      marginLeft: 12,
      [theme.breakpoints.down('md')]: {
        marginLeft: '-5px',
      },
    },
    selectAllCheckboxIndeterminate: {
      color: PRIMARY_BLUE,
    },
    selectAllCheckboxRoot: {
      borderRadius: 0,
      color: combinedColor(PLAIN_GREY, OPACITY_MEDIUM),
    },
    filtersWrapper: {
      display: 'flex',
      columnGap: 16,
    },
    customerSelect: {
      fontSize: '12px',
      fontWeight: 'bold',
      whiteSpace: 'nowrap',
    },
    searchAndSelectWrapper: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      flex: 1,
      alignItems: 'flex-start',
    },
    moreActions: {
      [theme.breakpoints.down('md')]: {
        height: 80,
      },
    },
    searchInputContainer: {
      width: 295,
      [theme.breakpoints.down('md')]: {
        width: '100%',
      },
    },
    searchWrapper: {
      display: 'flex',
      alignItems: 'center',
      columnGap: 16,
      [theme.breakpoints.down('md')]: {
        width: '100%',
      },
    },
    searchInput: {
      height: 28,
      marginTop: 1,
      width: '100%',
      borderRadius: '25px',
      color: DARKER_GREY,
      fontSize: '12px',
      lineHeight: '16px',
      padding: '5px',
      '& svg': {
        fontSize: FONT_SIZE_MEDIUM_CONFUSED,
        color: VERTICAL_SEPARATOR,
      },
      '& input': {
        padding: 0,
        width: 'fill-available',
        letterSpacing: 0.5,
      },
      '& fieldset': {
        borderColor: combinedColor(PLAIN_GREY, OPACITY_MEDIUM),
      },
    },
    actionsContainer: {
      gridArea: 'actions',
      flexDirection: 'row',
      maxWidth: '100%',
      width: '100%',
      alignItems: 'center',
      overflow: 'hidden',
      display: 'flex',
      justifySelf: 'center',
      '& svg': {
        fontSize: FONT_SIZE_MEDIUM_CONFUSED,
        margin: 4,
      },
    },
    actionButton: {
      width: '100%',
      fontSize: FONT_SIZE_SMALL,
    },
    actionsActive: {
      overflow: 'visible',
      justifyContent: 'flex-end',
    },
    actionButtonConfirm: {
      color: TEXT_PRIMARY_ACTION,
      fontSize: '12px',
    },
    actionButtonCancel: {
      color: TEXT_SECONDARY_ACTION,
      fontSize: '12px',
    },
    menuButton: {
      height: 37,
      fontSize: '12px',
      fontWeight: 'bold',
      lineHeight: '16px',
    },
    small: {
      marginBottom: 0,
      [theme.breakpoints.down('md')]: {
        margin: '20px 16px',
      },
    },
    sortContainer: {
      gridArea: 'sort',
      width: 'max-content',
    },
    filterContainer: {
      gridArea: 'filter',
      width: 'max-content',
      '& button': {
        border: `1px solid ${PRIMARY_BLUE}`,
      },
    },
    sortSelect: {
      fontSize: '12px',
      fontWeight: 'bold',
      color: PRIMARY_BLUE,
      [`& .${selectClasses['select']}`]: {
        ':focus': {
          backgroundColor: ACTION_TOOLBAR_BACKGROUND,
        },
      },
    },
    menuItems: {
      fontSize: FONT_SIZE_INBETWEEN,
    },
  }),

  { name: 'listToolbar' },
);
